import appModel from '../../../models/app-model'
import { useSnapshot } from 'valtio'
import { useEffect, useState } from 'react'
import { getBusinessCentralURLParams, getTaskReviewURLParams } from '../../../utils/general'
import CustomerWorkFlow from './customerWorkflow'
import CustomModal from '../../../components/customMessageModal/customMsgModal'
import ProductionSizeModal from './productionSizeModal'
import Dropdown from '../../../components/dropdown/dropdownMenu'
import Spinner from './spinner'
import NotesModal from './notesModal'
import NotesEmbroideryModal from './notesEmbroideryModal'
import { DefaultCustomerData, DesignDoc } from '../../../types/api-types'
import { InternalArtStates, InternalArtStatesDescriptions, isInReviewScenario } from '../../../types/art-status'
import { addDesignComment, approveDesign, handleRejectProof, markSewFileAsNotPaid, markSewFileAsPaid, sendDesignProofToCustomer, setProofToReady, updateDesignArtStatus, updateDesignDetails } from '../../../models/app-actions'
import WEINotesModal from './weiNotesModal'
import ChangeLayerName from './changeLayerNamesModal'
import { editableProperties, isAWAWProductType } from '../../../utils/artDetailsUtils'
import CommentBox from '../../../components/commentBox/commentBox'
import { getBCArtFeeForDocumentId, wizardDocArchive } from '../../../api/backend'
import { WEIProductTypes } from '../../../types/product-types'
import { addAuthorizationHeader, getAdminToken } from '../../../api/network'
import { getBackendApiUrl, getDWSUrl, getLNUrl } from '../../../config'
import { AxiosError } from 'axios'
import ContactInformationModal from './contactInformationModal'
import SewChargeModal from './sewChargeModal'
import SwapCustomCutLayersModal from './swapCustomCutLayersModal'

// Styles
import styles from './itemWorkFlow.module.css'
import ArtFeesModal from './artFeeModal'

interface ChatProps {
  designId: string;
  designStatus: string;
  activeConversationId: number;
  adminMode: boolean;
  archived: boolean;
  refreshNotes: () => Promise<void>;
  defaultCustomerData: DefaultCustomerData;
  refreshSewFilePrice: () => Promise<void>;
  refreshArtFeePrice: () => Promise<void>;
}

function findAllProductionUrls(
  obj: any,
  result: Record<string, string> = {}
): Record<string, string> {
  if (typeof obj !== "object" || obj === null) return result;

  if ("production_url" in obj && "pattern" in obj && typeof obj.pattern === "string") {
    result[obj.pattern] = obj.production_url;
  }

  for (const key in obj) {
    if (typeof obj[key] === "object") {
      findAllProductionUrls(obj[key], result);
    }
  }

  return result;
}

export function ItemWorkFlow(props: ChatProps): JSX.Element {
  const appSnap = useSnapshot(appModel);
  const wizardData = appSnap.activeDesignDoc?.wizardData;
  const [error, setError] = useState<any>(null);
  const customerId = appSnap.customerId;
  const isCustomerView = !props.adminMode
  const adminId = appSnap.adminId;
  const commentUserId = customerId || adminId;
  const [updatingConversation, setUpdatingConversation] = useState(false);
  const [commentValue, setCommentValue] = useState('');
  const [isProductionSizeModalOpen, setProductionSizeModalOpen] = useState<boolean>(false);
  const [isNotesModalOpen, setNotesModalOpen] = useState<boolean>(false);
  const [isEmbroideryNotesModalOpen, setEmbroideryNotesModalOpen] = useState<boolean>(false);
  const [sewChargeModalOpen, setSewChargeModalOpen] = useState<boolean>(false);
  const [artFeeModalOpen, setArtFeeModalOpen] = useState<boolean>(false);
  // const [isOneTimeChargeModalOpen, setIsOneTimeChargeModalOpen] = useState<boolean>(false);
  const businessCentralParams = getBusinessCentralURLParams();
  const reviewParams = getTaskReviewURLParams();
  const [openCustomerModal, setOpenCustomerModal] = useState<boolean>(false);
  const [openSendProofToCustomerModal, setOpenSendProofToCustomerModal] = useState<boolean>(false);
  const [openReviewReadyModal, setOpenReviewReadyModal] = useState<boolean>(false);
  const [openProofReadyModal, setOpenProofReadyModal] = useState<boolean>(false);
  const [openChangeLayerNameModal, setOpenChangeLayerNameModal] = useState<boolean>(false);
  const [openSwapLayersModal, setOpenSwapLayersModal] = useState<boolean>(false);
  const [openUpdateContactModal, setOpenUpdateContactModal] = useState<boolean>(false);
  const [showEditLayerNamesOption, setShowEditLayerNamesOption] = useState<boolean>(false);
  const [resetComment, setResetComment] = useState<boolean>(false);
  const [processing, setIsProcessing] = useState<boolean>(false);
  //const canComplete = !!appSnap.activeDesignDoc?.productionArtworkPreview?.length; //store.wizardDoc.activeWizardDoc?.statusID != OrderStatuses.Approved && !store.wizardDoc.activeWizardDoc?.lineID ;
  //const actionMenuEnabled = store.wizardDoc.activeWizardDoc?.statusID != OrderStatuses.Approved ;
  const isApproved = appSnap.activeDesignDoc?.statusID == InternalArtStates.APPROVED
  const isIncomplete = appSnap.activeDesignDoc?.statusID == InternalArtStates.INCOMPLETE
  const isReview = appSnap.activeDesignDoc?.statusID == InternalArtStates.REVIEW
  const canApprove = appSnap.activeDesignDoc?.statusID == "PEND_C" && !!appSnap.activeDesignDoc?.productionArtworkPreview?.length;
  const canSendProof = !isApproved && !!appSnap.activeDesignDoc?.productionArtworkPreview?.length;
  const [isLoading, setIsLoading] = useState(false);
  const [isWEINotesModalOpen, setWEINotesModalOpen] = useState<boolean>(false);
  const isProduction = businessCentralParams["SourceType"] == "Production";
  const isWEI = appSnap.activeDesignDoc?.docType == "WizardDesign" && WEIProductTypes.includes(appSnap.activeDesignDoc.wizardID)
  const isCustomProduct = appSnap.activeDesignDoc?.docType == "WizardDesign" && appSnap.activeDesignDoc.wizardID == "CustomProduct";
  const isLNTransfer = appSnap.activeDesignDoc?.docType === "LNTransfer";
  const isWizardDesign = appSnap.activeDesignDoc?.docType === "WizardDesign";
  const allowSewDiskFees = appSnap.activeDesignDoc?.docType == "WizardDesign" && wizardData.sewFile === "yes" && wizardData.sewFileType == "detailed";
  const [allowArtFees, setAllowArtFees] = useState<boolean>(false);
  const [purchased, setPurchased] = useState<boolean>(false);
  const [purchasedChecked, setPurchasedChecked] = useState<boolean>(false);
  const [showMarkSewFileAsPaidModal, setShowMarkSewFileAsPaidModal] = useState<boolean>(false);
  const existArtworkProof = Boolean(appSnap.activeDesignDoc?.productionArtworkPreview?.length);
  const [showShipWarningModal, setShowShipWarningModal] = useState(false);
  const [showProofShipWarningModal, setShowProofShipWarningModal] = useState(false);
  const [showShipWarningModalInitialComment, setShowShipWarningModalInitialComment] = useState(undefined as string | undefined);
  let canEditSewFile = false;
  const ccEditServices = ['CustomCut','CustomCutLetters','CustomCutNumbers']
  let canEditCC = !isApproved 
    && isWizardDesign 
    && ccEditServices.includes(wizardData.serviceType) 
    && wizardData.productType != 'CustomCutSignVinyl';
  const canEditDTL = !isApproved 
    && isWizardDesign 
    && wizardData.serviceType == 'CadPrintz'
    && wizardData.productType == 'DigitalTransfersLogos'

  const canMarkSewFilePaid = isApproved && (
    (appSnap.activeDesignDoc?.docType == "WizardDesign" && wizardData.sewFile === "yes")
    ||
    (appSnap.activeDesignDoc?.docType === "LNTransfer" && isAWAWProductType(appSnap.activeDesignDoc?.wizardID) && wizardData.disk == "yes")
  )
  const canSwapLayers = !isApproved && isWizardDesign && wizardData.serviceType === 'CustomCut' && wizardData.productType != 'CustomCutSignVinyl';

  if(!!adminId) {
    if(isWizardDesign) {
      const minifiedPI = {
        "DigitalTransfersLogos": {//this has been obtained from this document, make sure it gets updated if the document ever changes https://github.com/Stahls/stahls-dws/blob/43f862e1c32c136456f8756ac158ec4ed3b8277f/src/artwork-upload/config.json#L41260
          "sewFileMedia": {
            "DPSUT": true,
            "DPTXT": true
          }
        },
        "CustomKissCut": {
          "sewFileMedia": {
            "TWI": true,
            "PST": true
          }
        },
        "CustomCut": {
          "sewFileMedia": {
            "FEA": true,
            "TWI": true,
            "PST": true,
            "FEW": true
          }
        },
        "CustomCutLetters": {
          "sewFileMedia": {
            "FEA": true,
            "TWI": true,
            "PST": true,
            "FEW": true
          }
        },
        "CustomCutNumbers": {
          "sewFileMedia": {
            "FEA": true,
            "TWI": true,
            "PST": true,
            "FEW": true
          }
        }
      }
    
      var pi = minifiedPI[wizardData.productType as keyof typeof minifiedPI]
      var mediaProps = ["color1Material","color2Material","color3Material","color4Material","color5Material","colorAllMaterial","media"];
      for (const mediaProp of mediaProps) {
        var media = wizardData[mediaProp]
        if (media) { 
          if (!!pi && !!pi.sewFileMedia && Object.keys(pi.sewFileMedia).length > 0 && pi.sewFileMedia[media as keyof typeof pi.sewFileMedia] === true) {
            canEditSewFile = true;
          }
        }
      }
    }
    else if (isLNTransfer) {
      const LNWizardsWithSewFile = ['CustomMadeEasySublimatedTwill','CustomMadeEasyStandard','CustomMadeEasyKissCut','3DGreek','AutoStitch','CustomCut']
      if(LNWizardsWithSewFile.includes(appSnap.activeDesignDoc.wizardID)) {
        canEditSewFile = true;
      }
    }
  }


  const isBeingReviewed = [InternalArtStates.REVIEW_REQUESTED, InternalArtStates.REVIEW_IN_PROCESS, InternalArtStates.REVIEW_INFO_REQUESTED].includes(appSnap.activeDesignDoc?.statusID ?? InternalArtStates.OPEN);
  const reviewFinished = [InternalArtStates.REVIEW_READY, InternalArtStates.REVIEW_PAID].includes(appSnap.activeDesignDoc?.statusID ?? InternalArtStates.OPEN);

  useEffect(() => {
    if (customerId && appSnap.activeDesignDoc) {
      fetch(`${getBackendApiUrl()}/design-purchases/${appSnap.activeDesignDoc.id}`, {
        method: 'GET',
        headers: addAuthorizationHeader({
          'Content-Type': 'application/json'
        })
      }).then(async (purchasesResp) => {
        if (!purchasesResp.ok) throw new Error("Error getting purchase data " + await purchasesResp.text())
        const purchasesRespJson: { purchased: boolean } = await purchasesResp.json()
        console.log(`Design id ${appSnap.activeDesignDoc?.id} was${purchasesRespJson.purchased ? '' : ' not'} marked as purchased`)
        setPurchased(purchasesRespJson.purchased)
      }).catch(err => {
        throw err
      });
    }
  }, [customerId])

  useEffect(() => {
    if (props.adminMode) {
      const editable = hasEditableProperties(wizardData, editableProperties)
      setShowEditLayerNamesOption(editable);
      if(appSnap.activeDesignDoc && appSnap.activeDesignDoc.id == appSnap.activeDesignDoc.originalDocID && !!appSnap.activeDesignDoc.orderID && !!appSnap.activeDesignDoc.lineID && appSnap.activeDesignDoc.docType == "WizardDesign" && appSnap.activeDesignDoc.wizardID != "CustomProduct") {
        const checkArtFeeAllowed = async (id:typeof appSnap.activeDesignDoc.id) => {
          try {
            const v = await getBCArtFeeForDocumentId(id)
            setAllowArtFees(v.saleStatus == 'Draft')
          } catch {}
        }
        
        checkArtFeeAllowed(appSnap.activeDesignDoc.id)
      }

      if (appSnap.activeDesignDoc) {
        fetch(`${getBackendApiUrl()}/design-purchases/${appSnap.activeDesignDoc.id}`, {
          method: 'GET',
          headers: addAuthorizationHeader({
            'Content-Type': 'application/json'
          })
        }).then(async (purchasesResp) => {
          if (!purchasesResp.ok) throw new Error("Error getting purchase data " + await purchasesResp.text())
          const purchasesRespJson: { purchased: boolean } = await purchasesResp.json()
          console.log(`Design id ${appSnap.activeDesignDoc?.id} was${purchasesRespJson.purchased ? '' : ' not'} marked as purchased`)
          setPurchased(purchasesRespJson.purchased)
          setPurchasedChecked(true)
        }).catch(err => {
          throw err
        });
      }
    }
  }, [props.adminMode])

  const handleCommentChange = (comment: string) => {
    setCommentValue(comment);
  };

  const hasEditableProperties = (data: any, properties: string[]): boolean => {
    return properties.some(property => property in data);
  };

  const handleSaveClick = async (
    userToken: string,
    message: string,
    designId: string,
    lastMessageId: number,
    statusID: string,
    lineNo: number,
    updateStatus?: boolean,
    reviewTaskId?: string) => {
    if (!updatingConversation) {
      try {
        setIsLoading(true);
        setUpdatingConversation(true);

        await addDesignComment({
          userToken,
          message,
          lastMessageId,
          statusID,
          lineNo,
          docNo: businessCentralParams.DocNo,
          designId: designId,
          updateStatus,
          reviewTaskId
        })

        // Reset the textarea value
        setResetComment(prev => !prev);
        setUpdatingConversation(false);
      }
      catch (e) {
        setIsLoading(false);
        setError(e);
      }
      finally {
        setIsLoading(false);
      }
    }
  };

  // Handle dropdown click options 
  async function archive() {
    try {
      setIsLoading(true);

      await wizardDocArchive(props.designId);
      await updateDesignDetails();

      setError(null);
    } catch (error) {
      console.error(error);
      setError(error);
    }
    finally { setIsLoading(false) }
  }

  function changeSize() {
    setProductionSizeModalOpen(true);
  }

  function openWEINotes() {
    setWEINotesModalOpen(true)
  }

  function addNotes() {
    setNotesModalOpen(true);
  }

  function addSewFileInternalEmbroideryNotes() {
    setEmbroideryNotesModalOpen(true);
  }

  function approveForCustomer() {
    setOpenCustomerModal(true);
  }

  function sendProofToCustomer() {
    setOpenSendProofToCustomerModal(true);
  }

  function changeLayerName() {
    setOpenChangeLayerNameModal(true);
  }

  function swapLayers() {
    setOpenSwapLayersModal(true);
  }

  function updateContactInformation() {
    setOpenUpdateContactModal(true);
  }

  function editSewCharge() {
    setSewChargeModalOpen(true);
  }

  function editArtFees() {
    setArtFeeModalOpen(true);
  }

  // function editOneTimeCharges() {
  //   setIsOneTimeChargeModalOpen(true);
  // }

  async function assignOrderStatus(newStatus: InternalArtStates) {
    try {
      setIsLoading(true);

      await updateDesignArtStatus(
        props.designId,
        newStatus
      );

      setError(null);
    } catch (error) {
      console.error(error);
      setError(error);
    }
    finally { setIsLoading(false) }
  }

  async function assignToCSR() {
    await assignOrderStatus(InternalArtStates.PEND_S_CSR);
  }

  async function assignToDigitizing() {
    await assignOrderStatus(InternalArtStates.PEND_S_OUT);
  }

  async function assignToArtTeam() {
    await assignOrderStatus(InternalArtStates.PEND_S_ART);
  }

  async function assignToCustomer() {
    await assignOrderStatus(InternalArtStates.PEND_C);
  }

  async function handleRejectProofClick() {
    setIsLoading(true);
    const id = props.designId;

    try {
      await handleRejectProof(id, adminId as string)
      updateDesignDetails();
      setError(null);

    } catch (err) {
      console.log(err);
      setError(err);
    } finally { setIsLoading(false) }
  }

  // function addAlternativeDesign() {
  //   redirectToDWS(appSnap.activeDesignDoc?.id as string, appSnap.activeDesignDoc?.customerID as string, true, true);
  // }

  const confirmApproveArt = async (comment?: string) => {
    try {
      setIsProcessing(true);
      await approveDesign(props.designId);

      // Save comment without changing status
      if (comment) saveComment(comment, false);

      updateDesignDetails();
      setError(null);
    } catch (err: any) {
      if (err instanceof AxiosError) {
        const errorData = (err as AxiosError)?.response?.data
        const error = errorData == null ? null : typeof errorData == "object" && "error" in errorData && typeof errorData.error == "string" ? errorData.error : JSON.stringify(errorData)
        const errorShippingRegex = /^Failed to set the quantities to ship in Business Central. You cannot ship more than 0 units\.  CorrelationId:  [a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\.$/g

        if (error && errorShippingRegex.test(error)) {
          setShowShipWarningModal(true);
          return;
        }
      }

      console.log(err);
      setError(err);
    } finally {
      setIsProcessing(false);
      setOpenCustomerModal(false);
    }
  };

  const confirmSendProofToCustomer = async (comment?: string) => {
    try {
      setIsProcessing(true);
      await sendDesignProofToCustomer(props.designId);

      // Save comment without changing status
      if (comment) saveComment(comment, false);

      updateDesignDetails();
      setError(null);
    } catch (err: any) {
      if (err instanceof AxiosError) {
        const errorData = (err as AxiosError)?.response?.data
        const error = errorData == null ? null : typeof errorData == "object" && "error" in errorData && typeof errorData.error == "string" ? errorData.error : JSON.stringify(errorData)
        const errorShippingRegex = /^Failed to set the quantities to ship in Business Central. You cannot ship more than 0 units\.  CorrelationId:  [a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\.$/g

        if (error && errorShippingRegex.test(error)) {
          setShowShipWarningModalInitialComment(comment);
          setShowProofShipWarningModal(true);
          return;
        }
      }

      console.log(err);
      setError(err);
    } finally {
      setIsProcessing(false);
      setOpenSendProofToCustomerModal(false);
    }
  };

  const approveWithoutShipping = async () => {
    try {
      setIsProcessing(true);
      await approveDesign(props.designId, true);

      saveComment("Your artwork has been approved", false);

      updateDesignDetails();
      setError(null);
    } catch (err) {
      console.log(err);
      setError(err);
    } finally {
      setIsProcessing(false);
      setShowShipWarningModal(false);
    }
  }

  const sendProofWithoutShipping = async () => {
    try {
      setIsProcessing(true);
      await sendDesignProofToCustomer(props.designId, true);

      // Save comment without changing status
      if (showShipWarningModalInitialComment) saveComment(showShipWarningModalInitialComment, false);
      setShowShipWarningModalInitialComment(undefined);

      updateDesignDetails();
      setError(null);
    } catch (err) {
      console.log(err);
      setError(err);
    } finally {
      setIsProcessing(false);
      setShowProofShipWarningModal(false);
    }
  }

  const confirmProofIsReady = async () => {
    try {
      setIsProcessing(true)
      await setProofToReady(props.designId)
      updateDesignDetails();
    } catch (err) {
      console.log(err);
    } finally {
      setIsProcessing(false);
      setOpenProofReadyModal(false);
    }
  }

  const handleSizeChangeSuccess = (comment: string) => {
    if (comment)
      saveComment(comment);

    setProductionSizeModalOpen(false);
    updateDesignDetails();
  }

  // const handleOneTimeChargeSucess = (comment: string) => {
  //   if (comment)
  //     saveComment(comment);
  // }

  const handleSewChargeSuccess = async (comment: string) => {
    await props.refreshSewFilePrice()
    if (comment)
      saveComment(comment);
    setSewChargeModalOpen(false);
  }

  const handleArtFeeSuccess = async (comment: string) => {
    await props.refreshArtFeePrice()
    if (comment)
      saveComment(comment);
    setArtFeeModalOpen(false);
  }

  const handleEditLayerSuccess = (comment: string) => {
    if (comment)
      saveComment(comment);

    setOpenChangeLayerNameModal(false);
    updateDesignDetails();
  }

  const handleSwapLayersSuccess = (comment?: string) => {
    if (comment)
      saveComment(comment);

    setOpenSwapLayersModal(false);
    updateDesignDetails();
  }

  const handleNotesModalUpdate = async () => {
    await props.refreshNotes(); // Re-fetch notes from backend
  };

  const saveComment = (comment: string, updateStatus?: boolean) => {
    const nextStatus = isBeingReviewed ? (adminId ? "REVIEW_INFO_REQUESTED" : "REVIEW_IN_PROCESS") : (adminId ? "PEND_C" : "PEND_S_ART");
    const lineNo = Number(businessCentralParams?.DocLineNo);
    const reviewId = reviewParams.reviewId ? reviewParams.reviewId : undefined
    handleSaveClick(commentUserId as string
      , comment
      , props.designId
      , props.activeConversationId
      , nextStatus
      , lineNo
      , updateStatus
      , reviewId);
  }

  const markAsReviewReady = async (comment?: string) => {
    await assignOrderStatus(InternalArtStates.REVIEW_READY);

    if (comment)
      saveComment(comment);
  }

  const changeSewFilePaidStatus = async () => {
    try {
      setIsProcessing(true)
      if(purchased) {
        await markSewFileAsNotPaid(appSnap.activeDesignDoc?.id as string, isWizardDesign)
      }
      else {
        await markSewFileAsPaid(appSnap.activeDesignDoc?.id as string)
      }
      await props.refreshSewFilePrice();
      await updateDesignDetails();
      setPurchased(!purchased)
    } catch (err) {
      console.log(err);
    } finally {
      setIsProcessing(false);
      setShowMarkSewFileAsPaidModal(false);
    }
  }

  const patternBuildersprodUrls = findAllProductionUrls(wizardData);

  const menuItems = [
    ...(canMarkSewFilePaid && purchasedChecked ? [{ text: `Mark sew file as${purchased ? " not" : ""} paid`, onItemClicked: () => { setShowMarkSewFileAsPaidModal(true) } }] : []),
    ...(!isCustomProduct ? [{ text: 'Modify Size', onItemClicked: changeSize }] : []),
    ...(canEditSewFile ? [{ text: 'Edit Sew File Options', onItemClicked: () => {
          setIsLoading(true);
          if(isWizardDesign) {
            const returnUrl = new URL(window.location.href)
            const adminTokenKey = Array.from(returnUrl.searchParams.keys()).find(x => x.toLowerCase()=='admintoken') ?? 'adminToken';
            const adminIdKey = Array.from(returnUrl.searchParams.keys()).find(x => x.toLowerCase()=='adminid') ?? 'AdminId';
            const artIdKey = Array.from(returnUrl.searchParams.keys()).find(x => x.toLowerCase()=='artid') ?? 'artId';
            returnUrl.searchParams.delete(adminTokenKey)
            returnUrl.searchParams.delete(adminIdKey)
            returnUrl.searchParams.delete(artIdKey)
            const encodedReturnUrl = btoa(returnUrl.toString())
            const DWS_URL = getDWSUrl();
            const dwsWizard = "https://" + DWS_URL;
            window.location.replace(`${dwsWizard}?AdminId=${adminId}&customerToken=${getAdminToken()}&designId=${props.designId}&sewFileMode=true&ret=${encodedReturnUrl}`);
          }
          else if(isLNTransfer) {
            const returnUrl = new URL(window.location.href)
            const adminTokenKey = Array.from(returnUrl.searchParams.keys()).find(x => x.toLowerCase()=='admintoken') ?? 'adminToken';
            const artIdKey = Array.from(returnUrl.searchParams.keys()).find(x => x.toLowerCase()=='artid') ?? 'artId';
            returnUrl.searchParams.delete(adminTokenKey)
            returnUrl.searchParams.delete(artIdKey)
            const encodedReturnUrl = btoa(returnUrl.toString())

            const headers = {
                'Content-Type': 'application/json'
            };

            fetch(`${getBackendApiUrl()}/getEditParams`, {
                method: 'POST',
                headers,
                body: JSON.stringify({
                    docId: appSnap.activeDesignDoc.id
                })
            })
            .then((lnEditParams) => {
              if (!lnEditParams.ok) console.error("Failed to get edit parameters for LN wizard");

              return lnEditParams.json();
            })
            .then((editUrlData) => {
              const LN_URL = getLNUrl();

              const redirectUrl = new URL(LN_URL.indexOf('localhost') > -1
                  ? `http://${LN_URL}/index.html?wizardType=${appSnap.activeDesignDoc?.wizardID}&${editUrlData.urlParams}&customerToken=${getAdminToken()}&ret=${encodedReturnUrl}`
                  : `https://${LN_URL}/index.html?wizardType=${appSnap.activeDesignDoc?.wizardID}&${editUrlData.urlParams}&customerToken=${getAdminToken()}&ret=${encodedReturnUrl}`);
              redirectUrl.searchParams.set("designId",props.designId);
              redirectUrl.searchParams.set("sewFileMode",'1');

              window.location.replace(redirectUrl.toString());
            })

            
          }
          else {
            setIsLoading(false)
          }
     }}] : []),
    ...(canEditCC ? [{ text: 'Edit Custom Cut Options', onItemClicked: () => {
          setIsLoading(true);
          if(isWizardDesign) {
            const returnUrl = new URL(window.location.href)
            const adminTokenKey = Array.from(returnUrl.searchParams.keys()).find(x => x.toLowerCase()=='admintoken') ?? 'adminToken';
            const adminIdKey = Array.from(returnUrl.searchParams.keys()).find(x => x.toLowerCase()=='adminid') ?? 'AdminId';
            const artIdKey = Array.from(returnUrl.searchParams.keys()).find(x => x.toLowerCase()=='artid') ?? 'artId';
            returnUrl.searchParams.delete(adminTokenKey)
            returnUrl.searchParams.delete(adminIdKey)
            returnUrl.searchParams.delete(artIdKey)
            const encodedReturnUrl = btoa(returnUrl.toString())
            const DWS_URL = getDWSUrl();
            const dwsWizard = "https://" + DWS_URL;
            window.location.replace(`${dwsWizard}?AdminId=${adminId}&customerToken=${getAdminToken()}&designId=${props.designId}&ccEditMode=true&ret=${encodedReturnUrl}`);
          }
          else {
            setIsLoading(false)
          }
     }}] : []),
    ...(canEditDTL ? [{ text: 'Edit Digital Transfers/Logos Options', onItemClicked: () => {
          setIsLoading(true);
          if(isWizardDesign) {
            const returnUrl = new URL(window.location.href)
            const adminTokenKey = Array.from(returnUrl.searchParams.keys()).find(x => x.toLowerCase()=='admintoken') ?? 'adminToken';
            const adminIdKey = Array.from(returnUrl.searchParams.keys()).find(x => x.toLowerCase()=='adminid') ?? 'AdminId';
            const artIdKey = Array.from(returnUrl.searchParams.keys()).find(x => x.toLowerCase()=='artid') ?? 'artId';
            returnUrl.searchParams.delete(adminTokenKey)
            returnUrl.searchParams.delete(adminIdKey)
            returnUrl.searchParams.delete(artIdKey)
            const encodedReturnUrl = btoa(returnUrl.toString())
            const DWS_URL = getDWSUrl();
            const dwsWizard = "https://" + DWS_URL;
            window.location.replace(`${dwsWizard}?AdminId=${adminId}&customerToken=${getAdminToken()}&designId=${props.designId}&dtlEditMode=true&ret=${encodedReturnUrl}`);
          }
          else {
            setIsLoading(false)
          }
     }}] : []),
    ...(!isCustomProduct ? [{ text: 'Edit Layer Names', onItemClicked: changeLayerName, disabled: !showEditLayerNamesOption }] : []),
    ...(canSwapLayers ? [{ text: 'Swap Layers', onItemClicked: swapLayers }] : []),
    ...(!isCustomProduct ? [{ text: 'Send proof to Customer', onItemClicked: sendProofToCustomer, disabled: !canSendProof }] : []),
    ...(!isCustomProduct ? [{ text: 'Approve on behalf of Customer', onItemClicked: approveForCustomer, disabled: !canApprove }] : []),
    { text: 'Add Internal Notes', onItemClicked: addNotes },
    { text: 'Add Internal Embroidery Notes', onItemClicked: addSewFileInternalEmbroideryNotes },
    ...(isWEI ? [{ text: 'Add Notes for WEI products', onItemClicked: openWEINotes }] : []),
    ...((isWEI && !isApproved && existArtworkProof) ? [{ text: 'Reject Proof', onItemClicked: handleRejectProofClick }] : []),
    ...(props.adminMode && Object.keys(patternBuildersprodUrls).length > 0 ? Object.entries(patternBuildersprodUrls).map(([key, url]) => ({
      text: `Download ${key} pattern`,
      onItemClicked: () => window.open(url, "_blank"),
    })) : []),
    ...(!isApproved ? [{ text: 'Update Contact Information', onItemClicked: updateContactInformation }] : []),
    ...(!isProduction ? [props.archived ? { text: 'Unarchive', onItemClicked: archive } : { text: 'Archive', onItemClicked: archive }] : []),
    ...(allowSewDiskFees && !purchased ? [{ text: 'Add Sew Charge', onItemClicked: editSewCharge }] : []),
    ...(allowArtFees && !purchased ? [{ text: 'Set art fees', onItemClicked: editArtFees }] : []),
    // { text: 'Add Art Fee', onItemClicked: editOneTimeCharges },
    ...(isBeingReviewed ? [{ text: 'Mark as Reviewed', onItemClicked: () => { { setOpenReviewReadyModal(true) } } }] : []),

    // Submenu for Assign options
    ...(!isInReviewScenario(appSnap.activeDesignDoc?.statusID) ? [{
      text: 'Assign To',
      style: { background: '#F9FAFB', fontWeight: '600' },
      submenu: [
        ...(!isCustomProduct ? [{ text: 'Assign to CSR', onItemClicked: assignToCSR, style: { background: '#F9FAFB' } }] : []),
        ...(!isCustomProduct ? [{ text: 'Assign to Digitizing', onItemClicked: assignToDigitizing, style: { background: '#F9FAFB' } }] : []),
        { text: 'Assign to Art Team', onItemClicked: assignToArtTeam, style: { background: '#F9FAFB' } },
        { text: 'Assign to Customer', onItemClicked: assignToCustomer, style: { background: '#F9FAFB' } },
      ]
    }] : [])
  ];

  return (
    <>
      <div className={styles.wrapper}>
        {(props.adminMode) &&
          <>
            <div className={styles.titleWrapper}>
              <span className={styles.title}>Item Status : {appSnap.activeDesignDoc?.statusID ? InternalArtStatesDescriptions[appSnap.activeDesignDoc?.statusID].description : ''}</span>
              <Spinner spinning={isLoading}></Spinner>
            </div>
            <div className={styles.itemsWrapper}>

              {/* <button
                type="button"
                disabled={!canComplete}
                className={`${canComplete ? buttonClasses : disabledButtonClass}`}
                onClick={() => setOpenProofReadyModal(true)}
              >
                Proof Ready
              </button> */}

              <Dropdown buttonText="Actions"
                menuItems={menuItems}
                submenuDirection="left" />

              {/* Size Modal */}
              <ProductionSizeModal
                isOpen={isProductionSizeModalOpen}
                onClose={() => setProductionSizeModalOpen(false)}
                onSizeChangeSuccess={(e) => { handleSizeChangeSuccess(e) }}
                document={appSnap.activeDesignDoc as DesignDoc}
                isCustomerView={isCustomerView}
              />

              {/* Notes Modal */}
              <NotesModal
                isOpen={isNotesModalOpen}
                onClose={() => setNotesModalOpen(false)}
                documentId={appSnap.activeDesignDoc?.id}
                onNotesModalSuccess={() => handleNotesModalUpdate()}
              />

              {/* Internal Embroidery Notes Modal */}
              <NotesEmbroideryModal
                isOpen={isEmbroideryNotesModalOpen}
                onClose={() => setEmbroideryNotesModalOpen(false)}
                documentId={appSnap.activeDesignDoc?.id}
                currentNote={appSnap.activeDesignDoc?.wizardData?.sewFileInternalEmbroideryNotes}
                currentAuthor={appSnap.activeDesignDoc?.wizardData?.sewFileInternalEmbroideryNotesBy}
                onEmbroideryNoteUpdateSuccess={() => updateDesignDetails()}
              />

              {/* Customer confirm Modal */}
              <CustomModal
                isOpen={openCustomerModal}
                onClose={() => setOpenCustomerModal(false)}
                message="Approve on Behalf of the Customer?"
                onConfirm={(e) => { confirmApproveArt(e) }}
                processing={processing}
                confirmButtonText="Approve"
                showCancelButton={false}
                userId={commentUserId as string}
                isCustomerView={isCustomerView}
              />

              {/* Send proof to Customer confirm Modal */}
              <CustomModal
                isOpen={openSendProofToCustomerModal}
                onClose={() => setOpenSendProofToCustomerModal(false)}
                message="Send proof to the Customer?"
                onConfirm={(e) => { confirmSendProofToCustomer(e) }}
                processing={processing}
                confirmButtonText="Send"
                showCancelButton={false}
                userId={commentUserId as string}
                isCustomerView={isCustomerView}
                initialComment='Please review and approve your proof.'
              />

              {/* Approve without shipping Modal */}
              <CustomModal
                isOpen={showShipWarningModal}
                onClose={() => setShowShipWarningModal(false)}
                message="The item is already marked as shipped and cannot be shipped again. Do you want to approve without shipping?"
                onConfirm={approveWithoutShipping}
                processing={processing}
                confirmButtonText="Confirm"
                cancelButtonText="Cancel"
                showCancelButton={true}
                isCustomerView={isCustomerView}
              />

              {/* Send proof without shipping Modal */}
              <CustomModal
                isOpen={showProofShipWarningModal}
                onClose={() => setShowProofShipWarningModal(false)}
                message="The item is already marked as shipped and cannot be shipped again. Do you want to send the proof without shipping?"
                onConfirm={sendProofWithoutShipping}
                processing={processing}
                confirmButtonText="Confirm"
                cancelButtonText="Cancel"
                showCancelButton={true}
                isCustomerView={isCustomerView}
              />

              {/* Complete confirm Modal */}
              <CustomModal
                isOpen={openProofReadyModal}
                onClose={() => setOpenProofReadyModal(false)}
                message="Send to the customer for approval?"
                onConfirm={confirmProofIsReady}
                processing={processing}
                confirmButtonText="Confirm"
                showCancelButton={false}
                isCustomerView={isCustomerView}
              />

              {/* WEI notes Modal */}
              <WEINotesModal
                isOpen={isWEINotesModalOpen}
                onWEINotesUpdateSuccess={() => { setWEINotesModalOpen(false); updateDesignDetails(); }}
                onClose={() => { setWEINotesModalOpen(false) }}
                document={appSnap.activeDesignDoc as DesignDoc}
              />

              {/* One Time Additional charge modal */}
              {/* <OneTimeChargeModal
                isOpen={isOneTimeChargeModalOpen}
                onClose={() => { setIsOneTimeChargeModalOpen(false) }}
                document={appSnap.activeDesignDoc as DesignDoc}
                userId={commentUserId as string}
                onOneTimeChargeSuccess={(e) => { handleOneTimeChargeSucess(e) }}
                isCustomerView={isCustomerView}
              /> */}

              {/* Edit Layer Name modal */}
              <ChangeLayerName
                isOpen={openChangeLayerNameModal}
                onClose={() => setOpenChangeLayerNameModal(false)}
                onSuccess={(e) => { handleEditLayerSuccess(e); }}
                wizardData={wizardData}
                docId={appSnap.activeDesignDoc?.id}
                isCustomerView={isCustomerView}
              />

              {/* Swap Layers Modal */}
              <SwapCustomCutLayersModal
                isOpen={openSwapLayersModal}
                onClose={() => setOpenSwapLayersModal(false)}
                onSuccess={(e) => { handleSwapLayersSuccess(e); }}
                wizardData={wizardData}
                docId={appSnap.activeDesignDoc?.id}
              />

              {/* Add Sew Charge Modal */}
              <SewChargeModal
                isOpen={sewChargeModalOpen}
                onClose={() => { setSewChargeModalOpen(false) }}
                document={appSnap.activeDesignDoc as DesignDoc}
                addSewChargeSuccess={async (e) => { return handleSewChargeSuccess(e) }}
                isCustomerView={isCustomerView}
              />

              {/* Change art fees Modal */}
              <ArtFeesModal
                isOpen={artFeeModalOpen}
                onClose={() => { setArtFeeModalOpen(false) }}
                document={appSnap.activeDesignDoc as DesignDoc}
                addArtFeeSuccess={async (e) => { return handleArtFeeSuccess(e) }}
                isCustomerView={isCustomerView}
              />

              {/* Mark as REVIEW READY modal */}
              <CustomModal
                isOpen={openReviewReadyModal}
                onClose={() => setOpenReviewReadyModal(false)}
                message="Mark art as reviewed and ready to proceed?"
                onConfirm={(e) => { markAsReviewReady(e) }}
                processing={processing}
                confirmButtonText="Confirm"
                showCancelButton={false}
                userId={commentUserId as string}
                isCustomerView={isCustomerView}
              />

              {/* Contact Information Modal */}
              <ContactInformationModal
                isOpen={openUpdateContactModal}
                onClose={() => { setOpenUpdateContactModal(false) }}
                document={appSnap.activeDesignDoc as DesignDoc}
                defaultCustomerData={props.defaultCustomerData}
                onUpdateContactSuccess={() => { setOpenUpdateContactModal(false); updateDesignDetails(); }}
              />

              {/* Mark sew file as paid modal */}
              <CustomModal
                isOpen={showMarkSewFileAsPaidModal}
                onClose={() => {}}
                message={`Mark sew file as${purchased ? " not" : ""} paid`}
                onConfirm={changeSewFilePaidStatus}
                onCancel={() => !processing && setShowMarkSewFileAsPaidModal(false)}
                processing={processing}
                confirmButtonText="Yes"
                cancelButtonText="No"
                showCancelButton={true}
                isCustomerView={isCustomerView}
              />
            </div>
          </>
        }
        {(!props.adminMode) &&
          <>
            <CustomerWorkFlow
              itemId={props.designId}
              docType={appSnap.activeDesignDoc?.docType as string}
              wizardType={appSnap.activeDesignDoc?.wizardID as string}
              wasPurchased={purchased} />
          </>
        }
        {error && <div style={{ color: "red", fontWeight: 800 }}>{error.response.data.error}</div>}
        <ul role="list">
          {/* New comment form */}
          {(commentUserId && !isApproved && !isReview && !reviewFinished && !isIncomplete) && (
            <div className="">
              <form action="#" className="relative flex-auto">
                <div className={styles.commentWrapper}>
                  <label htmlFor="comment" className="sr-only">
                    {isCustomerView ? `Add your comment for the art team...` : `Add your comment for the customer...`}
                  </label>
                  <CommentBox
                    onCommentChange={handleCommentChange}
                    isCustomerView={isCustomerView}
                    resetComment={resetComment} />
                  <div className={styles.buttons}>
                    <button
                      type="button"
                      disabled={updatingConversation || isApproved}
                      className={styles.button}
                      onClick={() => {
                        const nextStatus = isBeingReviewed ? (adminId ? "REVIEW_INFO_REQUESTED" : "REVIEW_IN_PROCESS") : (adminId ? "PEND_C" : "PEND_S_ART");
                        const lineNo = Number(businessCentralParams?.DocLineNo);
                        const reviewId = reviewParams.reviewId ? reviewParams.reviewId : undefined
                        handleSaveClick(commentUserId
                          , commentValue
                          , props.designId
                          , props.activeConversationId
                          , nextStatus
                          , lineNo
                          , undefined
                          , reviewId);
                      }
                      }
                    >
                      Send
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </ul>
      </div>
    </>
  );
}